import { Injectable, inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoadingService } from '../services/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private loadingService = inject(LoadingService);
  requests: HttpRequest<unknown>[] = [];

  checkRequestCount(req: HttpRequest<unknown>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
      this.loadingService.isLoading.next(this.requests.length > 0);
    }
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Package V1 create/update and its prestation price updates already report
    // progress via their own corner notification (AsyncNotificationService),
    // so they must not also trigger the full-screen blocking loader.
    const isPackageV1SaveRequest =
      request.url.includes('package-v1s') &&
      (request.method === 'POST' || request.method === 'PUT');
    const isPackageV1PrestationPriceRequest =
      request.method === 'POST' &&
      (request.url.includes('/prices/import') || request.url.includes('/prices/range'));
    // Pending automatic/product contract "GO" actions also report progress via
    // their own corner notification (AsyncNotificationService).
    const isPackageV1UpdatesRequest = request.url.includes('package-v1-updates');

    if (
      (request.method === 'POST' ||
        request.method === 'PUT' ||
        request.method === 'DELETE') &&
      !request.url.includes('authenticate') &&
      !request.url.includes('refreshtoken') &&
      !request.url.includes('displayProductCache') &&
      !request.url.includes('calendar/price') &&
      !isPackageV1SaveRequest &&
      !isPackageV1PrestationPriceRequest &&
      !isPackageV1UpdatesRequest
    ) {
      this.requests.push(request);
      this.loadingService.isLoading.next(true);
      return Observable.create((observer: any) => {
        const subscription = next.handle(request).subscribe(
          (event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              this.checkRequestCount(request);
              observer.next(event);
            }
          },
          (err: any) => {
            this.checkRequestCount(request);
            observer.error(err);
          },
          () => {
            this.checkRequestCount(request);
            observer.complete();
          }
        );
        // teardown logic in case of cancelled requests
        return () => {
          this.checkRequestCount(request);
          subscription.unsubscribe();
        };
      });
    } else {
      return next.handle(request);
    }
  }
}
